import { ALBUM_SECTIONS, isHiddenSticker } from '../albumData';

const PREFIX_INDEX = (() => {
  const map = new Map();
  for (const sec of ALBUM_SECTIONS) {
    if (sec.codePrefix) {
      const count = sec.to - sec.from + 1;
      map.set(sec.codePrefix, {
        from: sec.from,
        count,
        sectionId: sec.id,
        sectionLabel: sec.label,
        name: sec.label,
      });
    }
    if (sec.countries) {
      const names = String(sec.subtitle || '').split(' · ');
      sec.countries.forEach((code, i) => {
        map.set(code, {
          from: sec.from + i * 20,
          count: 20,
          sectionId: sec.id,
          sectionLabel: sec.label,
          name: names[i] || code,
        });
      });
    }
  }
  return map;
})();

export const ALL_PREFIXES = [...PREFIX_INDEX.keys()];

export function getPrefixInfo(prefix) {
  if (!prefix) return null;
  return PREFIX_INDEX.get(String(prefix).toUpperCase()) || null;
}

export function codeToNumber(code) {
  if (!code) return null;
  const m = String(code).trim().toUpperCase().match(/^([A-Z]{2,4})(\d{1,3})$/);
  if (!m) return null;
  const prefix = m[1];
  const info = PREFIX_INDEX.get(prefix);
  if (!info) return null;
  const num = parseInt(m[2], 10);
  if (!Number.isFinite(num)) return null;
  // FWC trampa: el slot 20 es la portada FWC00 (no hay FWC20 en el print real).
  // Aceptamos "FWC0"/"FWC00" como slot 20 y rechazamos "FWC20".
  if (prefix === 'FWC') {
    if (num === 0) return info.from + info.count - 1;
    if (num >= info.count) return null;
  }
  if (num < 1 || num > info.count) return null;
  const n = info.from + num - 1;
  if (isHiddenSticker(n)) return null;
  return n;
}

const stripDiacritics = (s) =>
  String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export function searchPrefixes(query) {
  const all = [...PREFIX_INDEX.entries()].map(([prefix, info]) => ({ prefix, ...info }));
  const q = stripDiacritics(query || '').toLowerCase().trim();
  if (!q) return all;
  const startsByCode = [];
  const startsByName = [];
  const includes = [];
  for (const item of all) {
    const code = item.prefix.toLowerCase();
    const name = stripDiacritics(item.name).toLowerCase();
    if (code.startsWith(q)) startsByCode.push(item);
    else if (name.startsWith(q)) startsByName.push(item);
    else if (name.includes(q) || code.includes(q)) includes.push(item);
  }
  return [...startsByCode, ...startsByName, ...includes];
}

export function parseCodeList(text) {
  if (!text) return [];
  const tokens = String(text).split(/[,\s;]+/).map((s) => s.trim()).filter(Boolean);
  return tokens.map((raw) => {
    const n = codeToNumber(raw);
    if (n == null) return { raw, code: null, n: null, error: 'INVALID' };
    return { raw, code: raw.toUpperCase(), n, error: null };
  });
}

export function splitCodeParts(input) {
  const m = String(input || '').toUpperCase().match(/^([A-Z]+)(\d*)$/);
  if (!m) return null;
  return { prefix: m[1], digits: m[2] };
}
